// src/components/LoadingButton/LoadingButton.js
import React from "react";
import { Button, CircularProgress } from "@mui/material";

const LoadingButton = ({ loading, children, ...props }) => {
  return (
    <Button {...props} disabled={loading || props.disabled}>
      {loading ? (
        <>
          <CircularProgress size={15} style={{ color: "white" }} />
          <span className="ms-2">{children}</span>
        </>
      ) : (
        children
      )}
    </Button>
  );
};

export default LoadingButton;
